/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Inbound_Delivery_FromInputs */

const en_field_inbound_delivery_from = /** @type {(inputs: Field_Inbound_Delivery_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound delivery start`)
};

/**
* | output |
* | --- |
* | "Inbound delivery start" |
*
* @param {Field_Inbound_Delivery_FromInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_inbound_delivery_from = /** @type {((inputs?: Field_Inbound_Delivery_FromInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Inbound_Delivery_FromInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_inbound_delivery_from(inputs)
});